import _get from 'lodash/get';
import type { RootState } from '~/reducers/index';
import { RegistryCollectionStateType } from '~/reducers/registryCollections';

export const getRegistryCollections = (state: RootState): RegistryCollectionStateType =>
  _get(state, 'registryCollections');
